var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable func-call-spacing */
/* eslint-disable no-spaced-func */
/* eslint-disable max-statements */
import React, { useEffect, useState } from 'react';
import { useBlocker, useLoaderData, useRevalidator } from 'react-router';

import { useSetAtom } from 'jotai';
import { Translate } from "../../../../I18N";
import { FetchResponseError } from "../../../../../shared/JSONRequest";

import { getByType, remove, UploadService } from "../../../api/files";
import { Button, ConfirmationModal, Table, ConfirmNavigationModal } from "../../../Components/UI";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { notificationAtom } from "../../../atoms";
import {
  createColumns,
  FileList,
  UploadProgress,
  DropzoneModal,
  EditFileSidepanel } from "./components";




const customUploadsLoader =
(headers) =>
async () => {
  const files = (await getByType('custom', headers)).map((file) => _objectSpread(_objectSpread({}, file), {}, { rowId: file._id }));
  return files;
};

const uploadService = new UploadService('custom');

const CustomUploads = () => {
  const files = useLoaderData();
  const setNotifications = useSetAtom(notificationAtom);
  const revalidator = useRevalidator();
  const [selectedRows, setSelectedRows] = useState([]);
  const [fileToEdit, setFileToEdit] = useState();
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [showUploadsModal, setShowUploadsModal] = useState(false);
  const [confirmNavigationModal, setConfirmNavigationModal] = useState(false);
  const [showSidepanel, setShowSidepanel] = useState(false);
  const [modalProps, setModalProps] = useState(


    {
      action: () => {},
      items: []
    });

  const blocker = useBlocker(Boolean(uploadService.isUploading()));

  useEffect(() => {
    if (blocker.state === 'blocked') {
      setConfirmNavigationModal(true);
    }

    if (blocker.state === 'proceeding') {
      uploadService.abort();
    }
  }, [blocker, setConfirmNavigationModal]);

  const notify = (responses, message) => {
    const hasErrors = responses.find(
      (response) => response instanceof FetchResponseError || !response._id
    );
    const didUploadFiles = responses.find(
      (response) => !(response instanceof FetchResponseError) && response._id
    );

    if (didUploadFiles) {
      setNotifications({
        type: 'success',
        text: message
      });
    }

    if (hasErrors) {
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred")
      });
    }
  };

  const handleDelete = async (file) => {
    setConfirmationModal(true);
    setModalProps({
      items: [file],
      action: async () => {
        setConfirmationModal(false);
        const response = await remove(file._id);
        notify([response], /*#__PURE__*/_jsx(Translate, {}, void 0, "Deleted custom file"));
        await revalidator.revalidate();
      }
    });
  };

  const deleteMultiple = async () => {
    const filesToDelete = selectedRows.map((row) => row._id);
    setConfirmationModal(false);
    setSelectedRows([]);
    const responses = await Promise.all(filesToDelete.map(async (fileId) => remove(fileId)));
    notify(responses, /*#__PURE__*/_jsx(Translate, {}, void 0, "Deleted custom file"));
    await revalidator.revalidate();
  };

  return (/*#__PURE__*/
    _jsx("div", { className: "tw-content", style: { width: '100%', height: '100%', overflowY: 'auto' } }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Custom Uploads" }), /*#__PURE__*/

    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Table, {
      data: files,
      columns: createColumns(handleDelete, (file) => {
        setShowSidepanel(true);
        setFileToEdit(file);
      }),
      onChange: ({ selectedRows: selected }) => {
        setSelectedRows(files.filter((file) => file.rowId in selected));
      },
      enableSelections: true,
      header: /*#__PURE__*/
      _jsx(Translate, { className: "text-base font-semibold text-left text-gray-900 bg-white" }, void 0, "Custom Uploads"

      ) }

    )
    ), /*#__PURE__*/

    _jsx(SettingsContent.Footer, { className: "flex gap-2 justify-end items-center" }, void 0, /*#__PURE__*/
    _jsx(UploadProgress, { queueLength: uploadService.getFilesInQueue().length }),
    selectedRows.length > 0 && /*#__PURE__*/
    _jsx(Button, {
      styling: "solid",
      color: "error",
      onClick: () => {
        setConfirmationModal(true);
        setModalProps({ items: selectedRows, action: deleteMultiple });
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Delete")
    ), /*#__PURE__*/

    _jsx(Button, { styling: "solid", color: "primary", onClick: async () => setShowUploadsModal(true) }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Import asset")
    )
    )
    ), /*#__PURE__*/

    _jsx(DropzoneModal, {
      isOpen: showUploadsModal,
      setIsOpen: setShowUploadsModal,
      uploadService: uploadService,
      notify: notify }
    ),

    confirmationModal && /*#__PURE__*/
    _jsx(ConfirmationModal, {
      header: /*#__PURE__*/_jsx(Translate, {}, void 0, "Delete"),
      warningText: /*#__PURE__*/_jsx(Translate, {}, void 0, "Do you want to delete the following items?"),
      body: /*#__PURE__*/_jsx(FileList, { items: modalProps.items }),
      onAcceptClick: async () => modalProps.action(),
      onCancelClick: () => setConfirmationModal(false),
      dangerStyle: true }
    ),


    confirmNavigationModal && /*#__PURE__*/
    _jsx(ConfirmNavigationModal, {
      setShowModal: setConfirmNavigationModal,
      onConfirm: async () => {
        if (blocker.proceed) {
          blocker.proceed();
        }
      } }
    ), /*#__PURE__*/


    _jsx(EditFileSidepanel, {
      showSidepanel: showSidepanel,
      closeSidepanel: () => setShowSidepanel(false),
      file: fileToEdit }
    )
    ));

};


export { CustomUploads, customUploadsLoader };